/**
 * N1 — Tome I's existing international and RU BookVolume identifiers.
 * Product slug and both already-created BookVolume IDs address the same
 * reader UI; keep the URL's identifier for the region-local Book API.
 *
 * Exact allowlist: never send another volume through the Almond reader.
 * No product, access, content or BookVolume IDs are rewritten.
 */
const ALMOND_TOME_BOOK_ROUTE_IDS = new Set([
  "том-i-миндаль",
  "1bc60d79-3083-48a7-aafd-328723d88e55", // INT BookVolume
  "7d269770-6609-52c6-82dc-dbf576f019c2", // RU BookVolume
]);

export function isAlmondTomeBookRoute(identifier) {
  return typeof identifier === "string" &&
    ALMOND_TOME_BOOK_ROUTE_IDS.has(identifier);
}
